import React from 'react';
import { config } from '@react-spring/web'
import useScrollTo from 'react-spring-scroll-to-hook'
import { clickTab } from '../../../components/WETTabs';

const ErrorValidationSpan = ({ errMsg, elementName, elementId, keyEl }) => {
    const handleKeyDown = (event) => {
        // Check if the pressed key is 'Enter' or 'Space'
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Prevent the default action of the key
            // Call the function that would normally be called on click
            if (!!elementName) {
                clickTab(elementName.closest("details").id.split('-')[1]);
                scrollTo(elementName, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
                elementName.focus();
            } else {
                clickTab(elementId.closest("details").id.split('-')[1]);
                scrollTo(elementId, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
                elementId.focus();
            }
        }
    };

    const {scrollTo} = useScrollTo(config.molasses);
    return (
        <span 
            id={"span-"+keyEl}
            className="error-validation" 
            tabIndex="0" 
            onClick={!!elementName ? 
                () => {
                    elementName.focus(); 
                    clickTab(elementName.closest("details").id.split('-')[1]); 
                    scrollTo(elementName, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
                } 
            : 
                () => {
                    elementId.focus(); 
                    clickTab(elementId.closest("details").id.split('-')[1]); 
                    scrollTo(elementId, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
                }
            }
            onKeyDown={handleKeyDown}
        >
            {errMsg}
        </span>
    );
};

export default ErrorValidationSpan;